// theme modules
import { alerts } from './theme.alerts';
import { badges } from './theme.badges';
import { box } from './theme.box';
import { breakpoints } from './theme.breakpoints';
import { buttons } from './theme.buttons';
import { colors } from './theme.colors';
import { helper } from './theme.helper';
import { flex } from './theme.flex';
import { fontSizes } from './theme.fontSizes';
import { fontWeights } from './theme.fontWeights';
import { fonts } from './theme.fonts';
import { forms } from './theme.forms';
import { layout } from './theme.layout';
import { letterSpacings } from './theme.letterSpacings';
import { lineHeights } from './theme.lineHeights';
import { shadows } from './theme.shadows';
import { space } from './theme.space';
import { styles } from './theme.styles';
import { text } from './theme.text';

// theme export
export const theme = {
  // Add more if needed
  alerts,
  badges,
  box,
  breakpoints,
  buttons,
  colors,
  flex,
  helper,
  fonts,
  fontSizes,
  fontWeights,
  forms,
  layout,
  letterSpacings,
  lineHeights,
  shadows,
  space,
  styles,
  text,
};
